import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=2ae5d5d7&scoped=true&"
import script from "./RecentActivity.vue?vue&type=script&lang=js&"
export * from "./RecentActivity.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=2ae5d5d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5d5d7",
  null
  
)

export default component.exports